import React, { useEffect } from 'react';

import {
  Typography, Box, Button, useWidth,
} from 'vindi-ds-components';

import vindiLogo from '@assets/images/admin/logo-vindi.svg';
import gtm from '../../../components/google_tag_manager/configuration_gtm';

import templates from '../templates.json';
import styles from './styles';

const maxBreakpointsForCenterAlign = ['md', 'lg', 'xl'];

function determineSizes() {
  let textAlign = 'center';
  let titleVariant = 'h2';
  let buttonStyle = styles.loginButton;
  const boxStyle = styles.successMessage;

  if (!maxBreakpointsForCenterAlign.slice(1, 3).includes(useWidth())) {
    titleVariant = 'h4';
  }

  if (!maxBreakpointsForCenterAlign.includes(useWidth())) {
    textAlign = 'left';
    buttonStyle = styles.loginButtonMobile;
  }

  return {
    textAlign, titleVariant, boxStyle, buttonStyle,
  };
}

function Success({ user }) {
  const successMessages = templates.messages.success;
  const body = successMessages.body[user.status === 'active' ? 'userActive' : 'userInvited'];
  const {
    textAlign, titleVariant, boxStyle, buttonStyle,
  } = determineSizes();

  useEffect(() => {
    gtm();
  }, []);

  return (
    <Box id='gtm-signup-success' css={{ ...styles.main, ...boxStyle }}>
      <img src={vindiLogo} alt='Logo Vindi' style={styles.successMessageLogo} />
      <Typography variant={titleVariant} style={styles.title} component='h2'>
        {successMessages.title}
      </Typography>
      <Typography align={textAlign}>
        {body[0]}
        <Typography component='span' weight='bold'>{user.email}</Typography>
        .
      </Typography>
      <Typography align={textAlign}>{body[1]}</Typography>
      <Typography style={styles.footer} align={textAlign} variant='body2'>
        {successMessages.footer}
      </Typography>
      <Button style={buttonStyle} href='/users/sign_in'>Fazer login</Button>
    </Box>
  );
}

export default Success;
